// src/App.js
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import EventPage from './pages/EventPage';
import ResourcesPage from './components/app/ResourcesPage';
import EventWithNameTest from "./components/app/EventPostsWithCarousel.js";
import EventJoined from './components/app/EventJoined';
import ExploreEvents from './pages/ExploreEvents';
import PageNotFound from './pages/PageNotFound';
import Landing from './pages/Landing.js';
import SignInSide from './pages/SignInSide';
import SignUp from './pages/SignUp';
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./ProtectedRoute.js";
import Dashboard from './pages/Dashboard.js';
import Speakers from './components/admin/content/Speakers';
import Sponsors from './components/admin/content/Sponsors';
import Scheduler from './components/admin/content/Scheduler';
import People from './components/admin/content/People';
import Posts from './components/admin/content/Posts';
import HomeLanding from './components/admin/content/HomeLanding';
import AdminStart from './components/admin/AdminStart.js';
import Create from './components/admin/CreateEvent.js';
import Settings from './components/admin/content/Settings.js';
import TicketManager from './components/ticket/TicketManager.js';
import TicketCart from './components/ticket/TicketCart.js';
import BulkEvents from './components/admin/BulkAddEvents.js';
import RandomEvents from './components/admin/tests/GenerateEventsJson.js'
import Blog from './pages/Blog';

function App() {
  return (  
    <AuthProvider>  
      <Router>
        <Routes>
          <Route path="/test" element={<BulkEvents />} />
          <Route path="/random" element={<RandomEvents />} />

          {/* sign in */}
          <Route path="/signin" element={<SignInSide />} />
          <Route path="/signup" element={<SignUp />} /> 

          {/* admin welcome */}
          <Route path="/admin/welcome" element={ <ProtectedRoute><AdminStart /></ProtectedRoute>}/>   {/*change path to app.nkuvu.com/welcome when live*/}
          <Route path="/admin/create" element={ <ProtectedRoute><Create /></ProtectedRoute>}/>        {/*change path to app.nkuvu.com/create when live*/}          

          {/* admin event boundend */}
          <Route path="/admin/:eventCode" element={ <ProtectedRoute><Dashboard /></ProtectedRoute>}>    {/*change path to app.nkuvu.com/:eventID when live*/}            
            <Route index element={<HomeLanding />} /> 
            <Route path="speakers" element={<Speakers />} />
            <Route path="posts" element={<Posts />} />
            <Route path="people" element={<People />} />
            <Route path="sponsors" element={<Sponsors />} />
            <Route path="scheduler" element={<Scheduler />} />
            <Route path="settings" element={<Settings />} />
            <Route path="tickets" element={<TicketManager />} />
          </Route>

          {/* landing page */}
          <Route path="/" element={<Landing />} /> 

          <Route path="/explore" element={<ExploreEvents />} />                                       {/*change path to app.nkuvu.com/explore when live*/}
          <Route path="/explore/:eventCode" element={<EventPage />} />                                {/*change path to app.nkuvu.com/explore/:eventCode when live*/}          
          <Route path="/explore/:eventCode/cart" element={<TicketCart />} />   
          {/* <Route path="/join/:eventCode/resources" element={<ProtectedRoute><ResourcesPage /></ProtectedRoute>} />   */}
          {/* <Route path="/join/:eventCode/people" element={<ProtectedRoute><ResourcesPage /></ProtectedRoute>} />   */}
          
          {/* app */}
          <Route path="/join/:eventCode" element={<ProtectedRoute><EventJoined /></ProtectedRoute>} >     {/*change path to app.nkuvu.com/join/:eventID when live*/}
            <Route path="people" element={<EventWithNameTest />} />      
            <Route path="maps" element={<ExploreEvents />} />      
            <Route path="speaker" element={<ExploreEvents />} />      
            <Route path="resources" element={<ResourcesPage />} />      
          </Route>
          
          {/* not found */}
          <Route path="*" element={<PageNotFound />}/>

          {/* blog */}
          <Route path="blog" element={<Blog />}/>

        </Routes>
      </Router> 
    </AuthProvider> 
  );
}

export default App;
